import Organization from 'umg-ember-backend/components/record-explorer/for/organization';

<template>
  <Organization @records={{@model}} @recordType='organization' />
</template>
